function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_3924_42141)"
}, React.createElement("path", {
  d: "M14.9987 4.16667H4.9987C4.07822 4.16667 3.33203 4.91286 3.33203 5.83334V15.8333C3.33203 16.7538 4.07822 17.5 4.9987 17.5H14.9987C15.9192 17.5 16.6654 16.7538 16.6654 15.8333V5.83334C16.6654 4.91286 15.9192 4.16667 14.9987 4.16667Z",
  stroke: "black",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M13.332 2.5V5.83333",
  stroke: "black",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M6.66797 2.5V5.83333",
  stroke: "black",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M3.33203 9.16667H16.6654",
  stroke: "black",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), React.createElement("path", {
  d: "M8.33203 13.3333H11.6654",
  stroke: "black",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_3924_42141"
}, React.createElement("rect", {
  width: 20,
  height: 20,
  fill: "white"
})));

var SvgDatetimeIconDark = function SvgDatetimeIconDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDatetimeIconDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DatetimeIcon_Dark.0f88d75b.svg";
export { ForwardRef as ReactComponent };